module.exports = __webpack_public_path__ + "img/world.ce2d6c2a.png";